import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import InstitutionList from "./InstitutionList";
import InstitutionRegisteredForRetry from "./InstitutionRegisteredForRetry";

const InstitutionIndex = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div
      className="card"
      style={{ background: "transparent", padding: "0px 10%" }}
    >
      <TabView
        className=""
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel header="List Institutions ">
          <InstitutionList {...props} />
        </TabPanel>
        <TabPanel header="Institution registered for retry">
          <InstitutionRegisteredForRetry />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default InstitutionIndex;
